/**
 * Max length for Zip/Postal code form fields
 *
 * @type {number}
 */
export const FORM_POSTAL_CODE_MAX_LENGTH = 10;
/**
 * Max length for bank account number form fields
 *
 * @type {number}
 */
export const FORM_ACH_ACCOUNT_NUMBER_MAX_LENGTH = 16;
/**
 * Max length for bank routing number form fields
 *
 * @type {number}
 */
export const FORM_ACH_ROUTING_NUMBER_MAX_LENGTH = 9;
/**
 * Regular Expression for validation of international zip codes (numbers, letters, spaces, dashes)
 *
 * @type {RegExp}
 */
export const FORM_POSTAL_CODE_REGEXP = new RegExp(/^[a-zA-Z0-9-]*$/);
/**
 * Regular Expression for validation of alphanumeric fields
 *
 * @type {RegExp}
 */
export const FORM_ALPHANUMERIC_REGEXP = new RegExp(/^[a-zA-Z0-9]*$/);
/**
 * Regular Expression for validation of numeric fields
 * note: this is necessary because a-input does not respect maxLength on a type="number" input field
 *
 * @type {RegExp}
 */
export const FORM_NUMERIC_REGEXP = new RegExp(/^[0-9]*$/);
/**
 * Regular Expression for validation of email fields
 *
 * @type {RegExp}
 */
export const FORM_EMAIL_REGEXP = new RegExp(/^[a-zA-Z0-9-_@.]*$/);
